// extracted by mini-css-extract-plugin
module.exports = {"btn":"OutlinedButton-module--btn--z0ZS0"};